var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function({ hover }){return [_c('v-btn',{class:[_vm.highlighted, {
				'grey--text' : (!hover && !_vm.highlighted) || _vm.isLoading,
				'text--darken-2 white' : hover && !_vm.highlighted
			},
			'font-12 transparent'],attrs:{"elevation":"0","small":"","loading":_vm.isLoading,"ripple":false},on:{"click":_vm.action}},[_c('v-icon',{staticClass:"font-12 mr-2"},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.text)+" ")],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }